import { render, staticRenderFns } from "./sourceData.vue?vue&type=template&id=b2ea2506&scoped=true&"
import script from "./sourceData.vue?vue&type=script&lang=js&"
export * from "./sourceData.vue?vue&type=script&lang=js&"
import style0 from "./sourceData.vue?vue&type=style&index=0&id=b2ea2506&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ea2506",
  null
  
)

export default component.exports